import React from 'react';
import { IndexLink, Link } from 'react-router';
import './Header.scss';
import Logo from './assets/logo.png';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem } from 'reactstrap';

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.getNav = this.getNav.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  getNav() {
    if (Object.prototype.hasOwnProperty.call(this.props.store.getState().auth, 'sub') === false) {
      return null;
    }

    return (
      <Nav navbar>
        <NavItem>
          <Link onClick={this.toggle} to='/advisor/profile' className='HeaderNav__link nav-item nav-link' activeClassName='HeaderNav__link--active active'>Profile</Link>
        </NavItem>
        <NavItem>
          <Link onClick={this.toggle} to='/advisor/getinvolved' className='HeaderNav__link nav-item nav-link' activeClassName='HeaderNav__link--active active'>Get Involved</Link>
        </NavItem>
        <NavItem>
          <Link onClick={this.toggle} to='/advisor/university' className='HeaderNav__link nav-item nav-link' activeClassName='HeaderNav__link--active active'>Advisor University</Link>
        </NavItem>
        <NavItem>
          <Link onClick={this.toggle} to='/advisor/preferences' className='HeaderNav__link nav-item nav-link' activeClassName='HeaderNav__link--active active'>Preferences</Link>
        </NavItem>
        <NavItem>
          <Link onClick={this.toggle} to='/advisor/feedback' className='HeaderNav__link nav-item nav-link' activeClassName='HeaderNav__link--active active'>Feedback</Link>
        </NavItem>
        <NavItem>
          <Link onClick={this.toggle} to='/scheduler/' className='HeaderNav__link nav-item nav-link' activeClassName='HeaderNav__link--active active'>Schedule</Link>
        </NavItem>
        <div className="AlignRight">
          <NavItem>
            <Link onClick={this.toggle} to='/advisor/logout' className='HeaderNav__link nav-item nav-link'>Logout</Link>
          </NavItem>
        </div>
      </Nav>
    );
  }

  render() {
    return (
      <div className='page-layout__navbar--main'>
        <div className='container'>
          <Navbar expand="md" className='navbar-expand-md' inverse toggleable>
            <NavbarBrand href='/advisor/'>
              <img alt='Paragon One' className='header__LogoImage' src={Logo} />
            </NavbarBrand>
            {Object.prototype.hasOwnProperty.call(this.props.store.getState().auth, 'sub') && (
              <NavbarToggler onClick={this.toggle} className='hidden-lg-up' />
            )}

            <Collapse isOpen={this.state.isOpen} className='navbar-toggleable-lg' navbar>
              {this.getNav()}
            </Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/advisor/layouts/Header/index.js